export default __webpack_public_path__ + "static/media/dashboardPages.676506e4.svg";